import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const emailCheckpointMutation = graphql(/* GraphQL */ `
    mutation EmailCheckpoint($email: String!) {
        emailCheckpoint(email: $email) {
            result
        }
    }
`);
